var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContainerScrolling',{on:{"show-more":_vm.showMore}},[(_vm.discussions.length)?_c('div',{staticClass:"community-discussion-listing rounded-6 mt-12"},_vm._l((_vm.discussions),function({
        id,
        author,
        title,
        description,
        createdDate,
        type,
        repliesCount,
        votesCount,
        hasUserVoted,
      }){return _c('CommunityDiscussionListingDetail',{key:id,attrs:{"id":id,"author":author,"community":_vm.community,"date":createdDate,"description":description,"title":title,"type":type,"replies-count":repliesCount,"votes-count":votesCount,"has-user-voted":hasUserVoted}})}),1):_c('div',{staticClass:"mt-6 mb-14"},[_vm._v("\n    There are currently no topics available. If you've got something to share,\n    you can start your own by selecting the 'Start a discussion' button above.\n  ")]),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"text-center my-4"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","aria-label":"Loading content"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }